export default function CTASection() {
  return (
    <section id="contact" className="relative overflow-hidden">
      {/* Background image */}
      <img
        src="https://public.readdy.ai/ai/img_res/a0c56168806cdef5ffccdc86b0b06fad.jpg"
        alt="Smile By Dr. K Orthodontics appointment booking Chatsworth CA"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Warm-toned overlay — lighter and more inviting */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1C3528]/72 via-[#1C3528]/68 to-[#0F1E16]/80" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-28 md:py-36 text-center">

        <div className="flex items-center justify-center gap-3 mb-7">
          <span className="w-8 h-px bg-[#C4A96E]" />
          <span
            className="text-[#C4A96E] text-[10px] tracking-[0.32em] uppercase font-semibold"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Take the First Step
          </span>
          <span className="w-8 h-px bg-[#C4A96E]" />
        </div>

        <h2
          className="text-[46px] md:text-[66px] text-white font-semibold leading-[1.04] mb-6"
          style={{ fontFamily: 'Cormorant Garamond, serif', letterSpacing: '-0.015em' }}
        >
          Ready to Transform<br />
          <span className="font-light italic" style={{ color: '#C4A96E' }}>Your Smile?</span>
        </h2>

        <p
          className="text-white/60 text-lg leading-relaxed mb-12 max-w-lg mx-auto"
          style={{ fontFamily: 'DM Sans, sans-serif' }}
        >
          Book an appointment or request a virtual consultation — we&rsquo;re here to help you take the next step, on your terms and your timeline.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
          <a
            href="https://smilebydrkortez.com/request-appointment"
            target="_blank"
            rel="noopener nofollow"
            className="bg-[#C4A96E] hover:bg-[#B8994F] text-[#1C3528] font-bold text-base px-11 py-4.5 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center gap-2.5 justify-center py-4"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Book an Appointment
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href="https://smilebydrkortez.com/virtual-consult"
            target="_blank"
            rel="noopener nofollow"
            className="border-2 border-white/30 hover:border-white/60 hover:bg-white/8 text-white font-semibold text-base px-11 rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 flex items-center gap-2.5 justify-center py-4"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            <i className="ri-video-line" />
            Virtual Consultation
          </a>
        </div>

        {/* Contact details */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-9">
          <a
            href="tel:8183415150"
            className="flex items-center gap-3 cursor-pointer group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-[#C4A96E]/20 border border-[#C4A96E]/35 rounded-full flex-shrink-0">
              <i className="ri-phone-line text-[#C4A96E] text-sm" />
            </div>
            <span
              className="text-white/70 text-sm group-hover:text-white transition-colors"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              (818) 341-5150
            </span>
          </a>
          <div className="hidden sm:block w-px h-6 bg-white/15" />
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center bg-[#C4A96E]/20 border border-[#C4A96E]/35 rounded-full flex-shrink-0">
              <i className="ri-map-pin-2-line text-[#C4A96E] text-sm" />
            </div>
            <span
              className="text-white/60 text-sm"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              10234 Canoga Ave, Chatsworth, CA 91311
            </span>
          </div>
        </div>

      </div>
    </section>
  );
}
